export default __webpack_public_path__ + "static/media/cheatday@3x.ed0e7aee.jpg";